import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProspektrApi } from 'src/app/_shared/api/prospektr.api';
import { ActivityLoggerService } from 'src/app/_shared/service/activity-logger.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { ConfirmDialogComponent } from 'src/app/shared/modules/alerts/confirm-dialog/confirm-dialog.component';
import { SubscriptionPlanService } from 'src/app/shared/service/subscription-plan.service';
import { default as constants } from 'src/constant.json';
import { MyHomeService } from '../../service/my-home.service';
import { MyHomeState } from '../../state/my-home.state';
import { ContactAgentInfoComponent } from '../contact-agent-info/contact-agent-info.component';
import { CreateMyHomeDialogueComponent } from '../create-my-home-dialogue/create-my-home-dialogue.component';

@Component({
  selector: 'app-my-home-list',
  templateUrl: './my-home-list.component.html',
  styleUrls: ['./my-home-list.component.scss'],
})
export class MyHomeListComponent implements OnInit, OnChanges {
  userInfo: any;
  constructor(
    private myHomeState: MyHomeState,
    private dialog: MatDialog,
    private myHomeService: MyHomeService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private appState: AppState,
    private activityLoggerService: ActivityLoggerService,
    private userState: UserState,
    private prospektrApi: ProspektrApi,
    private subscriptionService: SubscriptionPlanService,
  ) { }

  @Input() myHomeList;
  selectedPmxId;
  selectedHomeValue;
  @Output() activeHomeChanged = new EventEmitter<boolean>();
  onDestroyNotifier$ = new Subject();
  sentContactMailInprogress = false;
  applyNowInprogress = false;

  contactLenderEnabled: boolean = false;
  contactAgentEnabled: boolean = false;
  listMyHomeEnabled: boolean = false;

  ngOnInit() {
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.userInfo = res;
        this.contactLenderEnabled = this.appState.companyInfoValue.appConfig?.myHome?.contactLenderEnabled || false;
        this.contactAgentEnabled = this.appState.companyInfoValue.appConfig?.myHome?.contactAgentEnabled || false;
        this.listMyHomeEnabled = this.appState.companyInfoValue.appConfig?.myHome?.listMyHomeEnabled || false;
      }
    });
  }

  ngOnChanges() {
    if (this.myHomeList && this.myHomeList.length) {
      if (!this.selectedPmxId) {
        this.selectedPmxId =
          this.myHomeState.activeHomeValue && this.myHomeState.activeHomeValue.PMXPropertyId
            ? this.myHomeState.activeHomeValue.PMXPropertyId
            : this.myHomeList[0].PMXPropertyId;
      }
    }
  }

  selectedHome(home) {
    const url = this.router
      .createUrlTree([], {
        relativeTo: this.activatedRoute,
        queryParams: { id: home.id },
      })
      .toString();
    this.location.go(url);
    this.selectedHomeValue = home;
    this.selectedPmxId = home.PMXPropertyId;
    this.myHomeState.mortgageListValue = home.mortgageList ? home.mortgageList : [];
    this.myHomeState.activeHomeValue = home;
    this.activeHomeChanged.emit(true);
  }

  addProperty() {
    if (!this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES.addMyHome.key)) return;

    let _this = this;
    this.dialog.open(CreateMyHomeDialogueComponent, {
      width: '385px',
      panelClass: 'custom-addProperty-container',
      disableClose: true,
      data: {
        proceedAction() {
          _this.selectedPmxId = null;
        },
      },
    });
  }

  deleteProperty(id) {
    let _this = this;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '385px',
      disableClose: true,
      hasBackdrop: true,
      data: {
        type: 'deleteMyHomeProperty',
        message: 'The selected property will be deleted from My Properties',
        title: 'Do you want to delete?',
        proceedAction: (status, callBack) => {
          if (status) {
            _this.selectedPmxId = null;
            _this.myHomeService
              .deleteMyHomeProperty(id)
              .pipe(takeUntil(this.onDestroyNotifier$))
              .subscribe((res: any) => {
                callBack({ status: true });
                let params = {
                  email: this.userState.userDetails.user_profile.email,
                  homeId: id,
                };
                _this.myHomeService.deleteMyHomeSubscription(params).subscribe((res: any) => { });
                this.selectedPmxId = this.myHomeState.activeHomeValue.PMXPropertyId;
                this.activeHomeChanged.emit(true);
              });
          } else {
            return false;
          }
        },
        proceedCancelAction: () => {
          dialogRef.close();
        },
      },
    });
  }

  tradeUpProperty() {
    this.myHomeState.openSpendForecastSheetValue = true;
  }

  contactAgent() {
    this.dialog.open(ContactAgentInfoComponent, {
      width: '440px',
      disableClose: true,
    });
  }

  contactLender() {
    this.myHomeService
      .contactLender({ homeId: this.myHomeState.activeHomeValue.id })
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.applyNowInprogress = res.isLoading;
      });
  }

  listMyHome(): void {
    // if (!this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES.listMyHome.key)) {
    //   return;
    // }

    const home = this.myHomeState.activeHomeValue;

    if (!home) {
      return;
    }

    const addressParts = [
      home.streetAddress,
      home.city,
      `${home.state || ''} ${home.zip || ''}`.trim(),
      'USA',
    ].filter((item) => item);

    const address = addressParts.join(', ');

    if (this.userInfo?.userType === 'investor') {
      const propertyAddress = {
        city: home.city,
        state: home.state,
        street: home.streetAddress,
        zip: home.zip,
      };

      this.logUserActivity(
        constants.LOGGER.myHome.category,
        constants.LOGGER.myHome.action.listMyHome.key,
        home?.PMXPropertyId,
        propertyAddress
      );
    }

    if (this.appState.companyInfoValue?.appConfig?.myHome?.listMyHomeNotificationEnabled) {
      const notifyListMyHomeObj = {
        propertyDetails: {
          Address: address,
        },
        action: 'listMyHome',
      };

      this.prospektrApi
        .notifyListMyHome(notifyListMyHomeObj)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe(
          (res: any) => { },
          (err: any) => { }
        );
    }

    this.router.navigate(['/listMyHome'], {
      queryParams: {
        search: address,
        // homeId: home.id,
      },
    });
  }

  logUserActivity(category, action, PMXPropertyId, address) {
    let loggerParams = {
      category: category,
      action: action,
    };
    let inputData = {
      PMXPropertyId: PMXPropertyId,
      address: address,
    };
    this.activityLoggerService.logActivity(loggerParams, inputData);
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
